import { render, staticRenderFns } from "./Approve.vue?vue&type=template&id=18ad0862"
import script from "./Approve.vue?vue&type=script&lang=js"
export * from "./Approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports